import React from "react";

export const Balance = ({ transactions, time, year }) => {
  const amounts = transactions.map((transaction) => transaction.value);
  const total = amounts.reduce((acc, item) => (acc += item), 0).toFixed(2);
  function numberWithCommas(x) {
    return x.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
  }

  return (
    <>
    {year ? (<h4>{time}ly Savings ({year}) </h4>) : (<h4>Savings This {time}</h4>
)}
      <h1>${numberWithCommas(total)}</h1>
    </>
  );
};
